module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui segment"
  }, [_vm._h('h3', {
    staticClass: "ui header"
  }, ["Profile"]), " ", _vm._h('ProfileDetail', {
    attrs: {
      "profile": _vm.profile
    }
  }), " ", _vm._h('br'), _vm._h('br'), " ", _vm._h('router-link', {
    staticClass: "ui green button",
    attrs: {
      "to": "edit",
      "append": ""
    }
  }, ["Edit"])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17172288!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 239
// module chunks = 2